import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, Subject, switchMap } from 'rxjs';
import { Coach } from '../../_shared/models/coach.model';

@Injectable({ providedIn: 'root' })
export class CoachService {
  coaches$ = new Subject<Coach[]>();
  coaches: Coach[] = [];
  constructor(private http: HttpClient) {
    this.coaches$.subscribe(_coaches => this.coaches = _coaches);
  }  

  getAllCoaches() {
    return this.http.get<any>(`api_endpoint` + `/user/my-coaches`, {});
  }

  create(payload: any) {
    return this.http.post<any>(`api_endpoint` + `/user/create/coach`, payload);
  }
  
  update(id:any,payload: any) {
    return this.http.post<any>(`api_endpoint` + `/user/update-coach`, payload);
  }


}
